// /src/pages/BenefitsPage.jsx
import React from "react";
import styled from "styled-components";
import BrandHeader from "../components/BrandHeader";
import PromoBanner from "../components/PromoBanner";

// ✅ 캐릭터/이미지 임포트
import carImg from "../assets/images/car.png";
import carKakaoImg from "../assets/images/car_kakaot.png";
import dogImg from "../assets/images/character_dog.png";
import bearImg from "../assets/images/character_bear.png";
import rabbitImg from "../assets/images/character_rabbit.png";
import bearHeartsImg from "../assets/images/character_bear_hearts.png";

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg,#D7E8FF 0%, #EAF3FF 100%);
  display:flex; flex-direction:column;
`;
const Sheet = styled.div`
  background:#F7FAFF;
  box-shadow:0 -4px 20px rgba(0,0,0,.05);
  min-height:100dvh; display:flex; flex-direction:column;
`;
const Body = styled.div`
  flex:1; padding:16px;
  display:grid; grid-template-rows:auto 1fr auto;
  row-gap:14px;
`;
const Section = styled.section`
  background:transparent;
  display:flex; flex-direction:column; gap:16px;
`;
const BottomPad = styled.div`
  height:max(24px, env(safe-area-inset-bottom));
`;

export default function BenefitsPage() {
    return (
        <Wrap>
            <Sheet>
                <Body>
                    <BrandHeader subtitle="혜택" />
                    <Section>
                        {/* 1. 웰컴 쿠폰 (곰 하트 캐릭터) */}
                        <PromoBanner
                            leftTop="지금 가입하면"
                            leftBottom="웰컴쿠폰 4종\n즉시 지급"
                            gradient="linear-gradient(90deg,#FF9A9E 0%,#F6416C 100%)"
                            imgSrc={bearHeartsImg}
                        />
                        {/* 2. 앱 전용 첫 결제 할인 (카카오T 자동차 캐릭터) */}
                        <PromoBanner
                            leftTop="앱 전용"
                            leftBottom="첫 결제시\n10% 할인쿠폰"
                            gradient="linear-gradient(90deg,#42E695 0%,#3BB2B8 100%)"
                            imgSrc={carKakaoImg}
                        />
                        {/* 3. 친구 추천 포인트 (토끼 캐릭터) */}
                        <PromoBanner
                            leftTop="친구 추천"
                            leftBottom="서로에게\n포인트 지급"
                            gradient="linear-gradient(90deg,#8E2DE2 0%,#4A00E0 100%)"
                            imgSrc={rabbitImg}
                        />
                    </Section>
                    <BottomPad />
                </Body>
            </Sheet>
        </Wrap>
    );
}
